import React from 'react';
import SEOHead from './SEOHead';

// 龙虎榜页面SEO
export const LongHuBangSEO = () => {
  return (
    <SEOHead
      title="A股龙虎榜数据分析 - 实时龙虎榜排行榜 | 股票信号网"
      description="专业A股龙虎榜数据分析平台，提供实时龙虎榜排行榜、机构席位分析、游资动向追踪。深度解析龙虎榜背后的投资逻辑，助力股票投资决策。"
      keywords="A股龙虎榜,龙虎榜数据,龙虎榜分析,机构席位,游资动向,龙虎榜排行榜,股票龙虎榜,实时龙虎榜,龙虎榜查询,投资分析"
      url="https://stocksignals.cn/longhubang"
    />
  );
};

// 金融工具页面SEO
export const ToolsSEO = () => {
  return (
    <SEOHead
      title="金融工具箱 - 仓位管理计算器 | 投资风险评估工具 | 股票信号网"
      description="专业金融工具集合，包含仓位管理计算器、风险评估工具、收益率计算器、止损止盈计算器等。科学管理投资仓位，控制投资风险。"
      keywords="仓位管理计算器,投资工具,风险评估,收益率计算,止损止盈,资金管理,投资计算器,股票工具,金融计算器,风险控制"
      url="https://stocksignals.cn/tools"
    />
  );
};

// 捐赠页面SEO
export const DonateSEO = () => {
  return (
    <SEOHead
      title="支持我们 - 捐赠页面 | 股票信号网"
      description="感谢您对股票信号网的支持！您的捐赠将帮助我们提供更好的A股龙虎榜数据分析服务和金融工具。"
      keywords="捐赠,支持,股票信号网,龙虎榜,金融工具,投资平台"
      url="https://stocksignals.cn/donate"
    />
  );
};

// 港股美股页面SEO
export const HKUSStockSEO = () => {
  return (
    <SEOHead
      title="港股美股实时行情 - 海外股票数据分析 | 股票信号网"
      description="提供港股、美股实时行情数据，海外股票投资分析工具。覆盖恒生指数、纳斯达克、道琼斯等主要指数，助力全球投资决策。"
      keywords="港股行情,美股数据,海外股票,恒生指数,纳斯达克,道琼斯,港股分析,美股分析,全球股市,海外投资"
      url="https://stocksignals.cn/hkus"
    />
  );
};

// 首页SEO（默认）
export const HomeSEO = () => {
  return (
    <SEOHead
      title="股票信号网 - A股龙虎榜数据分析平台 | 港股美股实时行情 | 金融工具箱"
      description="专业的股票数据分析平台，提供A股龙虎榜实时数据、港股美股行情、仓位管理计算器等金融工具。助力投资者做出明智的投资决策。"
      keywords="股票信号网,A股龙虎榜,港股行情,美股数据,股票分析,仓位管理,金融工具,投资计算器,股票信号,实时行情,投资分析,风险管理"
      url="https://stocksignals.cn"
    />
  );
};